import React, { useRef } from 'react';

/**
 * TiltCard — carte avec inclinaison 3D suivant le curseur + reflet lumineux.
 * Désactive l'effet si l'utilisateur préfère les mouvements réduits.
 */
const prefersReduced =
  typeof window !== 'undefined' &&
  window.matchMedia &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const TiltCard = ({ className = '', children, max = 9, glow = true, ...rest }) => {
  const ref = useRef(null);

  const handleMove = (e) => {
    const node = ref.current;
    if (!node || prefersReduced) return;
    const rect = node.getBoundingClientRect();
    const px = (e.clientX - rect.left) / rect.width;
    const py = (e.clientY - rect.top) / rect.height;
    const rx = (0.5 - py) * max * 2;
    const ry = (px - 0.5) * max * 2;
    node.style.transform = `perspective(900px) rotateX(${rx}deg) rotateY(${ry}deg) translateY(-6px)`;
    if (glow) {
      node.style.setProperty('--mx', `${px * 100}%`);
      node.style.setProperty('--my', `${py * 100}%`);
    }
  };

  const reset = () => {
    const node = ref.current;
    if (!node) return;
    node.style.transform = '';
  };

  return (
    <div
      ref={ref}
      onMouseMove={handleMove}
      onMouseLeave={reset}
      className={`tilt ${className}`}
      style={
        glow
          ? {
              backgroundImage:
                'radial-gradient(420px circle at var(--mx,50%) var(--my,0%), rgba(176,107,255,0.16), transparent 45%)',
            }
          : undefined
      }
      {...rest}
    >
      {children}
    </div>
  );
};

export default TiltCard;
